export default "__VITE_ASSET__DCVIfPOf__"